/**
 * This file contains the mapping for the new Content Wrapper sticky colors
 * Since the new stickies have a main color (body) and an accent color (stroke and fold)
 * See the mapping here:
 * https://www.figma.com/design/6PL9bS0pAb47Du0kBOC98b/%F0%9F%8C%AF-Content-wrapper?node-id=753-7309&m=dev
 */

export const accentForLightColorMap = {
  'color.background.input': 'color.background.accent.gray.subtler.hovered',
  'color.background.accent.blue.subtlest': 'color.background.accent.blue.subtler.hovered',
  'color.background.accent.purple.subtlest':
    'color.background.accent.purple.subtler.hovered',
  'color.background.accent.magenta.subtlest':
    'color.background.accent.magenta.subtler.hovered',
  'color.background.accent.red.subtlest': 'color.background.accent.red.subtler.hovered',
  'color.background.accent.orange.subtlest':
    'color.background.accent.orange.subtle.hovered',
  'color.background.accent.yellow.subtlest':
    'color.background.accent.yellow.subtler.hovered',
  'color.background.accent.lime.subtlest':
    'color.background.accent.lime.subtlest.pressed',
  'color.background.accent.green.subtlest':
    'color.background.accent.green.subtler.hovered',
  'color.background.accent.teal.subtlest': 'color.background.accent.teal.subtle.hovered',
};

export const accentForMediumColorMap = {
  'color.background.accent.gray.subtlest': 'color.background.accent.gray.subtle',
  'color.background.accent.blue.subtler': 'color.background.accent.blue.subtle',
  'color.background.accent.purple.subtler': 'color.background.accent.purple.subtle',
  'color.background.accent.magenta.subtler': 'color.background.accent.magenta.subtle',
  'color.background.accent.red.subtler': 'color.background.accent.red.subtle',
  'color.background.accent.orange.subtler': 'color.background.accent.orange.subtle',
  'color.background.accent.yellow.subtler': 'color.background.accent.yellow.subtle',
  'color.background.accent.lime.subtlest.hovered': 'color.background.accent.lime.subtle',
  'color.background.accent.teal.subtlest.hovered': 'color.background.accent.teal.subtle',
  'color.background.accent.green.subtlest.hovered':
    'color.background.accent.green.subtle',
};

export const accentForStrongColorMap = {
  'color.background.accent.gray.subtler.hovered': 'color.background.accent.gray.bolder',
  'color.background.accent.blue.subtlest.pressed': 'color.background.accent.blue.bolder',
  'color.background.accent.purple.subtlest.pressed':
    'color.background.accent.purple.bolder',
  'color.background.accent.magenta.subtlest.pressed':
    'color.background.accent.magenta.bolder',
  'color.background.accent.red.subtlest.pressed': 'color.background.accent.red.bolder',
  'color.background.accent.orange.subtlest.pressed':
    'color.background.accent.orange.bolder',
  'color.background.accent.yellow.subtlest.pressed':
    'color.background.accent.yellow.bolder',
  'color.background.accent.lime.subtlest.pressed': 'color.background.accent.lime.bolder',
  'color.background.accent.green.subtlest.pressed':
    'color.background.accent.green.bolder',
  'color.background.accent.teal.subtlest.pressed': 'color.background.accent.teal.bolder',
};
